import { logger } from '../../lib/logging'
import storage from '../../lib/localstorage.jsx'
import { Authentication } from './authentication'
import { InvalidCredentials } from './invalidCredentials'
import { SessionNotAuthenticated } from './sessionNotAuthenticated'

export class DemoAuthentication extends Authentication {
  init () {
    logger.debug('Authenticating locally...')
    return this.app.feathers
      .reAuthenticate()
      .then(({ user }) => {
        return this.afterLogin(user).then((data) => {
          logger.debug('Authenticated locally', { user })
          return data
        })
      }).catch(error => {
        if (error.name === 'NotAuthenticated') {
          throw new SessionNotAuthenticated()
        } else {
          throw error
        }
      })
  }

  login ({ email, password }) {
    logger.debug('Logging in', { email })
    return this.app.feathers.authenticate({
      email: email,
      password,
      strategy: 'local'
    }).then(({ user }) => {
      logger.debug('Logged in successfully', { user })
      return this.afterLogin(user)
    }).catch((error) => {
      if (error.message === 'Invalid login') {
        throw new InvalidCredentials()
      }

      throw error
    })
  }

  logout (redirectTo) {
    logger.debug('Logging out')
    const path = redirectTo || '/login'
    this.app.feathers.logout()
    storage.clear()

    return this.app.redirect(path)
  }

  refresh () {
    return this.app.feathers.reAuthenticate()
  }

  publicPages () {
    return [
      ...super.publicPages(),
      '/'
    ]
  }
}
